export const GET_PROMOTED_EVENTS = "GET_PROMOTED_EVENTS";